class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.mql = window.matchMedia('(min-width: 1200px)');
    this.header = document.querySelector('.header-wrapper');
    this.summaryElement = this.mainDetailsToggle.querySelector('summary');
    this.summaryElement.addEventListener('keydown', this.onSummaryKeyDown.bind(this));
    this.summaryElement.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryElement.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.submenuLinks = this.mainDetailsToggle.querySelectorAll('ul a');
    this.submenuLinks.forEach((link, index) => {
      link.addEventListener('keydown', (event) => this.onSubmenuKeyDown(event, index));
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseEnter() {
    if (this.mainDetailsToggle.open) return;
    this.open();
  }

  onMouseLeave() {
    if (this.mainDetailsToggle.open) {
      this.close();
    }
  }

  onSummaryClick(event) {
    if (event.target.closest('a')) return;
    event.preventDefault();
  }

  onSummaryKeyDown(event) {
    switch (event.key) {
      case 'Enter':
      case ' ':
      case 'ArrowDown':
        event.preventDefault();
        if (!this.mainDetailsToggle.open) {
          this.open();
          // Move focus to the first item in submenu
          const firstLink = event.target.parentElement.querySelector('ul').querySelector('a');
          if (firstLink) firstLink.focus();
        }
        break;
    }
  }

  onSubmenuKeyDown(event, index) {
    const total = this.submenuLinks.length;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        const nextIndex = (index + 1) % total;
        this.submenuLinks[nextIndex].focus();
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (index === 0) {
          // Loop focus to last item
          this.submenuLinks[this.submenuLinks.length - 1].focus();
        } else {
          this.submenuLinks[index - 1].focus();
        }
        break;
      case 'Escape':
        event.preventDefault();
        this.close();
        this.summaryElement.focus();
        break;
      case 'Tab':
        if (event.shiftKey) {
          // Shift + Tab
          event.preventDefault();
          this.close();
          this.summaryElement.focus();
        } else {
          // Tab to next visible element
          this.close();
          focusNextElement(this.summaryElement, getFocusableElements(document));
        }
        break;
    }
  }
}

customElements.define('header-menu', HeaderMenu);

class AnnouncementBar extends DetailsDisclosure {
  constructor() {
    super();
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.overlay = this.querySelector('.modal-overlay');
    this.closeButton = this.mainDetailsToggle.querySelector('.announcement-bar__close');
    this.closeButton.addEventListener('click', this.onCloseClick.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.overlay.addEventListener('click', this.close.bind(this));
    window.addEventListener('scroll', this.onScrollPastAnnouncements.bind(this));
    window.addEventListener('resize', this.onScrollPastAnnouncements.bind(this));

    window.addEventListener('resize', () => {
      if (this.overlay.classList.contains('show')) {
        this.setOverlayHeight();
      }
    });
  }

  onScrollPastAnnouncements() {
    const announcementBar = this.querySelector('.announcement-bar__details-container').getBoundingClientRect();
    const header = document.querySelector('.section-header').getBoundingClientRect();
    if (!this.querySelector('details').open) return;

    if (announcementBar.bottom <= header.bottom) {
      this.close();
    }
  }

  adjustmentsOnOpen() {
    this.setOverlayHeight();
    this.overlay.classList.add('show');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.content.focus();
    trapFocus(this.content);
  }

  onCloseClick() {
    if (this.mainDetailsToggle.open) {
      this.close();
    }
  }

  onSummaryClick(event) {
    if (this.mainDetailsToggle.open) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      this.adjustmentsOnOpen();
    }
  }

  onFocusOut() {
    return;
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.adjustmentsOnOpen();
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.overlay.classList.remove('show');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

    removeTrapFocus(this.activeElement);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setOverlayHeight() {
    const main = document.querySelector('main');
    const footer = document.querySelector('.shopify-section-group-footer-group');
    const mainHeight = main ? main.offsetHeight : 0;
    const footerHeight = footer ? footer.offsetHeight : 0;
    const overlayHeight = mainHeight + footerHeight;

    this.overlay.style.setProperty('--overlay-after-height', `${overlayHeight}px`);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
